import { MATCH } from './messages';

const matchValidation = (fields, key, criteria) => {
  const field = fields[key];
  const matchField = fields[criteria.value];
  const message = criteria.message || MATCH;
  return matchField !== field ? message : null;
};
export default matchValidation;
